import React, { useState } from 'react';
import { Search, ChevronDown, XCircle, PlusCircle, ArrowUpDown } from 'lucide-react';
import { ProjectCard } from './ProjectCard';
import { FilterBar, FilterDef, SortOption } from './FilterBar';
export const PROJECTS = [{
  id: 1,
  name: 'Denali',
  type: 'Portfolio Sale',
  status: 'Active',
  sellers: 'Thunder Bay Partners, Bracebridge Partners',
  buyers: 'Alma Bay LLC, Alma Bay II LLC',
  advisoryLead: 'Parry Sound Advisory',
  sellerLegal: 'Sherbrooke LLP',
  buyerLegal: 'Quinte & Belleville LLP',
  lastUpdated: "2 Mar '26"
}, {
  id: 2,
  name: 'Matterhorn',
  type: 'Portfolio Sale',
  status: 'Completed',
  sellers: 'Primary Grove Inc.',
  buyers: 'Banana Grove Inc.',
  advisoryLead: 'Philstone Advisory',
  sellerLegal: 'Fort York LLP',
  buyerLegal: 'Southbay & Brune',
  lastUpdated: "15 Feb '26"
}, {
  id: 3,
  name: 'Fuji',
  type: 'Portfolio Sale',
  status: 'Completed',
  sellers: 'Panther Lime LLC',
  buyers: 'Signal Hill LLC',
  advisoryLead: 'Granite Springs Advisors',
  sellerLegal: 'Armour LLP',
  buyerLegal: 'Forester Nixon',
  lastUpdated: "10 Jan '26"
}, {
  id: 4,
  name: 'Cascade',
  type: 'LP Interest Sale',
  status: 'Active',
  sellers: 'Redwood Capital Partners',
  buyers: 'Northshore Equity Fund III',
  advisoryLead: 'Clearwater Advisory',
  sellerLegal: 'Hastings & Cole LLP',
  buyerLegal: 'Bridgeport Legal Group',
  lastUpdated: "28 Feb '26"
}, {
  id: 6,
  name: 'Everest',
  type: 'GP-Led Continuation',
  status: 'Completed',
  sellers: 'Summit Ventures Fund IV',
  buyers: 'Horizon Secondary Partners',
  advisoryLead: 'Pinnacle Advisory Group',
  sellerLegal: 'Crawford & Sterling LLP',
  buyerLegal: 'Blackwood Legal Partners',
  lastUpdated: "5 Dec '25"
}, {
  id: 7,
  name: 'Summit',
  type: 'LP Interest Sale',
  status: 'Completed',
  sellers: 'Birchwood Pension Trust',
  buyers: 'Lakeshore Capital LLC',
  advisoryLead: 'Ridgemont Advisory',
  sellerLegal: 'Pemberton LLP',
  buyerLegal: 'Dunbar & Fitch',
  lastUpdated: "20 Nov '25"
}, {
  id: 8,
  name: 'Diamond',
  type: 'Portfolio Sale',
  status: 'Active',
  sellers: 'BlackRock',
  buyers: 'TBD',
  advisoryLead: 'Campbell Lutyens',
  sellerLegal: 'Akin Gump',
  buyerLegal: 'TBD',
  lastUpdated: "9 Apr '26"
}];
export function ProjectsContent({
  onProjectSelect,
  onProjectConsentFilter
}: {
  onProjectSelect?: (project: any) => void;
}) {
  const [typeFilter, setTypeFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [sortBy, setSortBy] = useState('status-active');
  const filters: FilterDef[] = [{
    key: 'type',
    label: 'Filter by Type',
    options: [{
      value: 'Portfolio Sale',
      label: 'Portfolio Sale'
    }, {
      value: 'LP Interest Sale',
      label: 'LP Interest Sale'
    }, {
      value: 'Direct Secondary',
      label: 'Direct Secondary'
    }, {
      value: 'GP-Led Continuation',
      label: 'GP-Led Continuation'
    }]
  }, {
    key: 'status',
    label: 'Filter by Status',
    options: [{
      value: 'Active',
      label: 'Active'
    }, {
      value: 'Completed',
      label: 'Completed'
    }]
  }];
  const sortOptions: SortOption[] = [{
    value: 'status-active',
    label: 'Sort: Active first'
  }, {
    value: 'status-completed',
    label: 'Sort: Completed first'
  }, {
    value: 'name-asc',
    label: 'Sort: Name A–Z'
  }, {
    value: 'name-desc',
    label: 'Sort: Name Z–A'
  }];
  const filterValues = {
    type: typeFilter,
    status: statusFilter
  };
  const handleFilterChange = (key: string, value: string) => {
    if (key === 'type') setTypeFilter(value);
    if (key === 'status') setStatusFilter(value);
  };
  const handleClearAll = () => {
    setTypeFilter('');
    setStatusFilter('');
  };
  const sortedProjects = [...PROJECTS].sort((a, b) => {
    if (sortBy === 'status-active') {
      if (a.status === 'Active' && b.status !== 'Active') return -1;
      if (a.status !== 'Active' && b.status === 'Active') return 1;
      return 0;
    }
    if (sortBy === 'status-completed') {
      if (a.status === 'Completed' && b.status !== 'Completed') return -1;
      if (a.status !== 'Completed' && b.status === 'Completed') return 1;
      return 0;
    }
    if (sortBy === 'name-asc') return a.name.localeCompare(b.name);
    if (sortBy === 'name-desc') return b.name.localeCompare(a.name);
    return 0;
  });
  const filteredProjects = sortedProjects.filter(p => {
    if (typeFilter && p.type !== typeFilter) return false;
    if (statusFilter && p.status !== statusFilter) return false;
    return true;
  });
  return <div className="p-10 pb-32 max-w-[110rem] mx-auto" data-id="element-671">
      <div className="flex justify-between items-center mb-10" data-id="element-672">
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-673">Projects</h1>
        <div className="flex w-80 shadow-sm rounded-md overflow-hidden border border-gray-300" data-id="element-674">
          <input type="text" placeholder="Search Projects..." className="flex-1 px-4 py-2.5 text-sm outline-none" data-id="element-675" />
          <button className="bg-[#458b85] hover:bg-[#3a7570] text-white px-4 py-2.5 transition-colors" data-id="element-676">
            <Search className="w-4 h-4" data-id="element-677" />
          </button>
        </div>
      </div>

      <FilterBar filters={filters} filterValues={filterValues} onFilterChange={handleFilterChange} onClearAll={handleClearAll} sortOptions={sortOptions} sortValue={sortBy} onSortChange={setSortBy} actions={<button className="bg-[#458b85] hover:bg-[#3a7570] text-white rounded-md py-2 px-4 flex items-center transition-colors text-sm font-medium" data-id="element-679">
            <PlusCircle className="w-4 h-4 mr-2" data-id="element-680" />
            Create Project
          </button>} data-id="element-678" />

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8" data-id="element-681">
        {filteredProjects.map(project => <ProjectCard key={project.id} project={project} onSelect={() => onProjectSelect?.(project)} data-id="element-682" />)}
      </div>
    </div>;
}